import { FETCH_SUPPLIERS, REJECTED, SUPPLIER } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';
import { SUPPLIERS, toApiPayload } from 'utils/import/columns';
import { apiRequest } from 'utils/request';

// CUSTOM ACTIONS
const handleError = (TYPE, error, dispatch) => {
    console.log('error: ', error);
    if (error.response) {
        if (error.response.status === 401) {
            dispatch({ type: 'LOGOUT' });
        } else {
            dispatch({ type: TYPE + REJECTED, payload: error.response.statusText });
        }
    } else {
        dispatch({ type: TYPE + REJECTED, payload: 'Unknown error' });
    }
};

const importSuppliersMultiple = data => dispatch => {
  // The spreadsheet's column names become the API's here and nowhere else, so
  // the file keeps its own contract when the fields are renamed again. The
  // raw-materials import has done this since the file contract was written;
  // this one had an empty mapping and so never called it, which is why `ativo`
  // reached the API unchanged and every imported supplier landed with a null
  // `active`.
  const submitData = toApiPayload(data, SUPPLIERS.translateFileHeadersToApiFields);
  return apiRequest('/suppliers/batch_import/', 'POST', submitData)
        .then(response => {
            // Insertion on DB takes a while so the FETCH is delayed
            setTimeout(() => dispatch({ type: FETCH_SUPPLIERS }), 5000);
        })
        .catch(error => handleError(SUPPLIER, error, dispatch));
};

// ACTIONS
const rawActions = actionsFactory(SUPPLIER);
const actions = {
    ...rawActions,
    ...thunkFactory(SUPPLIER, '/suppliers/'),
    importSuppliers: importSuppliersMultiple
};
export { actions };

// REDUCER
const initialState = {
    ids: [],
    models: {},
    loaded: false,
    loading: false,
    errorMessage: '',
    submitting: false
};

const options = {
    orderBy: {
        what: ['name'],
        how: ['asc']
    }
};

export default reducerFactory(SUPPLIER, initialState, options);

// SAGAS
const sagas = sagasFactory(SUPPLIER, '/suppliers/', { scopedByAccount: true });
export { sagas };
